import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import { CmpsAccordionItemComponent } from '@cmps/ng-uikit';

import { CaResult } from '../core';
import { Phase } from '../dialog';

import { setCaResult } from './function/set-ca-result.function';
import { setCollapsedProTips } from './function/set-collapsed-pro-tips.function';
import { currentState } from './state';
import { State } from './state.model';

@Component({
    selector: 'cmps-ca-evaluation',
    templateUrl: './ca-evaluation.component.html',
    host: {
        class: 'cmps-ca-evaluation',
    },
})
export class CaEvaluationComponent {
    @ViewChildren(CmpsAccordionItemComponent)
    private readonly _items: QueryList<CmpsAccordionItemComponent>;

    @Input() get caResult(): CaResult {
        return this._caResult;
    }

    set caResult(value: CaResult) {
        this._caResult = value;
        setCaResult(value);
    }

    @Input() showReasoning: boolean;
    @Input() asAutomatedCheckList: boolean;
    @Input() asManualCheckList: boolean;

    // eslint-disable-next-line accessor-pairs
    @Input() set phase(value: Phase) {
        this._state.phase = value;
    }

    @Input() get collapsed(): boolean {
        return this._collapsed;
    }

    set collapsed(value: boolean) {
        const manual = this._collapsed === value;
        this._collapsed = value;
        if (manual) {
            // TODO fix CmpsAccordionItemComponent
            this._items?.forEach((e) => (value ? e.close() : e.open()));
        }
    }

    @Input() get collapsedProTips(): boolean {
        return this._collapsedProTips;
    }

    set collapsedProTips(value: boolean) {
        this._collapsedProTips = value;
        setCollapsedProTips(value);
    }

    /** @private */ _state: State;
    /** @private */ _caResult: CaResult;
    /** @private */ _collapsed: boolean;
    /** @private */ _collapsedProTips: boolean;

    constructor() {
        this._state = currentState();
    }
}
